module.exports = __webpack_public_path__ + "img/employee-interview-white.76817d3d.svg";